console.log('[custom-cart-drawer] gestartet');

// Doppelte Events verhindern
if (!window.__cartDrawerHandlerAttached) {
  window.__cartDrawerHandlerAttached = true;

  const forms = document.querySelectorAll('form[action^="/cart/add"]');

  forms.forEach((form) => {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      console.log('[custom-cart-drawer] Intercepting form submit:', form);

      const formData = new FormData(form);

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((res) => {
          if (!res.ok) throw new Error('Fehler beim Hinzufügen zum Warenkorb');
          return res.json();
        })
        .then(() => {
          console.log('[custom-cart-drawer] Produkt hinzugefügt. Lade Drawer...');

          return fetch(window.location.pathname + '?sections=cart-drawer');
        })
        .then((res) => res.json())
        .then((data) => {
          const drawer = document.querySelector('cart-drawer');
          if (!drawer) {
            console.warn('[custom-cart-drawer] Kein <cart-drawer> Element gefunden');
            return;
          }

          // Update Drawer-Inhalt
          drawer.innerHTML = data['cart-drawer'];
          drawer.classList.add('is-open');
          document.body.classList.add('drawer-open');

          console.log('[custom-cart-drawer] Drawer geöffnet');
        })
        .catch((err) => {
          console.error('[custom-cart-drawer] Fehler:', err);
        });
    });
  });
} else {
  console.log('[custom-cart-drawer] Handler bereits registriert.');
}
